<div
  class="container {{ backgroundType }} {{ backgroundFormat }}"
  [class.click]="clickable"
  (click)="onClick()">
  <img
    class="logo"
    src="assets/img/logo/glaucio-logo-colorful.svg"
    alt="Gláucio Logo">
</div>
